import { render, staticRenderFns } from "./modgenius-plan-selector.vue?vue&type=template&id=83bc462a"
import script from "./modgenius-plan-selector.vue?vue&type=script&lang=js"
export * from "./modgenius-plan-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports